import { render, staticRenderFns } from "./Urbanism.vue?vue&type=template&id=32dd2559&"
import script from "./Urbanism.vue?vue&type=script&lang=js&"
export * from "./Urbanism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports